import { ParsedQuery } from 'query-string';
import { useParams } from 'react-router-dom';
import { useFilters } from './useFilters';
import {
  IPatchReportingGroupBody,
  IPostReportingGroupBody,
  IReportFilters,
  deleteReportingGroup,
  deleteReportingGroupMember,
  patchReportingGroup,
  postReportingGroup,
} from '../services/reports';
import { getReportsSetupParticipants, getReportsSetupRequest } from '../services/surveys';
import { THEME as theme } from '../styles/theme';

export const useReportsSetup = () => {
  const { currentFilters } = useFilters();
  const { surveyId } = useParams();
  const downloadReportsSetup = async (
    surveyId: string,
    type?: 'team' | 'executive',
    overrideFilters: ParsedQuery = {}
  ) => {
    const { ...filters } = currentFilters;
    const params = {
      ...filters,
      ...overrideFilters,
      perPage: filters.perPage || '7',
      type,
    };

    return await getReportsSetupRequest(surveyId, params);
  };

  const downloadReportsSetupOneItem = async (surveyId: string, type?: 'team' | 'executive') => {
    const { search } = currentFilters;
    return await getReportsSetupRequest(surveyId, { perPage: '1', search, type: type });
  };

  const getTypeStyle = (
    type: 'team' | 'executive'
  ): { borderColor: string; backgroundColor: string; marginRight: string } => {
    switch (type) {
      case 'team':
        return {
          marginRight: '29px',
          borderColor: theme.colors.support.green[100],
          backgroundColor: theme.colors.support.green[10],
        };
      case 'executive':
        return {
          marginRight: '0px',
          borderColor: theme.colors.accent.violet[70],
          backgroundColor: theme.colors.accent.violet[10],
        };
    }
  };

  const addNewReport = async (body: IPostReportingGroupBody) => {
    const id = surveyId || '1';
    return await postReportingGroup(id, body);
  };

  const editReport = async (groupId: string, body: IPatchReportingGroupBody) => {
    const id = surveyId || '1';
    return await patchReportingGroup(groupId, id, body);
  };

  const deleteReport = async (groupId: string) => {
    const id = surveyId || '1';
    return await deleteReportingGroup(groupId, id);
  };

  const deleteReportMember = async (groupId: string, memberId: string) => {
    const id = surveyId || '1';
    return await deleteReportingGroupMember(groupId, id, memberId);
  };

  const downloadMembers = async (surveyId: string, groupId: string, filters: IReportFilters) => {
    if (!filters.perPage) {
      return await getReportsSetupParticipants(surveyId, groupId, { ...filters, perPage: '5' });
    }
    return await getReportsSetupParticipants(surveyId, groupId, filters);
  };

  return {
    deleteReport,
    deleteReportMember,
    downloadReportsSetup,
    getTypeStyle,
    addNewReport,
    downloadMembers,
    downloadReportsSetupOneItem,
    editReport,
  };
};
